import { useContext, useEffect, useState } from "react";
import styles from "./Youtube.module.scss";
import { MobileContext } from "../../providers/MobileContext";

const Youtube = ({ channelInfo, mainVideo, videoList }) => {
  const isMobile = useContext(MobileContext);
  const { title, customUrl, description, thumbnails } = channelInfo.snippet;
  const { subscriberCount, videoCount, viewCount } = channelInfo.statistics;
  const [newVideoList, setNewVideoList] = useState([]);

  const calCount = (num) => {
    if (num < 1000) {
      return num;
    } else if (num < 1000000) {
      return Math.round(num / 1000) + "K";
    } else {
      return Math.round(num / 1000000) + "M";
    }
  };

  useEffect(() => {
    if (isMobile) {
      if (videoList.length < 2) {
        setNewVideoList(videoList[0]);
      } else {
        setNewVideoList([videoList[0], videoList[1]]);
      }
    } else {
      setNewVideoList(videoList);
    }
  }, [isMobile]);

  return (
    <div className={styles.youtube_wrapper}>
      <a
        className={styles.youtube_profile_wrapper}
        href={`https://www.youtube.com/${customUrl}`}
        target="_blank"
        rel="noreferrer"
        style={{ flexDirection: isMobile ? "column" : " row" }}
      >
        <img src={thumbnails.high.url} alt="유튜브 채널 프로필 이미지" />
        <div className={styles.profile_info_wrapper}>
          <div
            className={styles.user_title}
            style={{
              textAlign: isMobile ? "center" : "left",
              paddingTop: isMobile ? "2rem" : "0",
            }}
          >
            {title}
          </div>
          <div
            className={styles.user_info_wrapper}
            style={{ justifyContent: isMobile ? "center" : "left" }}
          >
            <div>{calCount(subscriberCount)} Subscribers</div>
            <div>{calCount(videoCount)} Videos</div>
            <div>{calCount(viewCount)} Views</div>
          </div>
          <div className={styles.user_description}>{description}</div>
        </div>
      </a>
      <div className={styles.main_video_wrapper}>
        <a
          href={`https://www.youtube.com/watch?v=${mainVideo.id}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={mainVideo.snippet.thumbnails.medium.url}
            alt="메인 영상 보기"
          />
        </a>
      </div>
      <div className={styles.video_list_wrapper}>
        <div className={styles.sub_title}>동영상</div>
        <div
          className={styles.video_list}
          style={{ gridTemplateColumns: isMobile ? "unset" : "repeat(3, 1fr)" }}
        >
          {newVideoList.map((video) => (
            <a
              href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
              target="_blank"
              rel="noreferrer"
              className={styles.video_wrapper}
              key={video.id.videoId}
            >
              <p>{video.videoId}</p>
              <img
                src={video.snippet.thumbnails.medium.url}
                alt="유튜브 영상 썸네일"
              />
              <div className={styles.video_title}>{video.snippet.title}</div>
              <div className={styles.video_date}>
                {video.snippet.publishedAt.slice(0, 10)}
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Youtube;
